import dynamic from 'next/dynamic';
import { ReservationLookupTypes } from './ReservationLookup.types';

export const ReservationLookupMGP = dynamic<ReservationLookupTypes>(() =>
  import('./ReservationLookup').then(module => module.ReservationLookup)
);
